
/** @jsxImportSource @emotion/react */
import TextField from '@mui/material/TextField';
import tw, { styled } from 'twin.macro';
import List from "../../data/list.json";
import Material from "../../data/material.json";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import useStorageData from '../../hooks/useStorageData';
import useLocalization from '../../hooks/useLocalization';


const InventoryPanel = () => {
  const { lang } = useLocalization();

  const { MaterialType } = List;
  const NormalMaterial = Object.keys(Material).filter((key) => Material[key].type === "normal").sort((a,b) => Material[a].order - Material[b].order)
  const CropsMaterial = Object.keys(Material).filter((key) => Material[key].type === "crops").sort((a,b) => Material[a].order - Material[b].order)
  const AnimalMaterial = Object.keys(Material).filter((key) => Material[key].type === "animal").sort((a,b) => Material[a].order - Material[b].order)

  return (
      <InventoryPanelWrapper className={``}>
        <InventoryWrapper>
          <InventoryTitle>{MaterialType["normal"].label[lang]}</InventoryTitle>
          <InventoryGrid>
            {NormalMaterial.map((key) => <Item key={key} dataKey={key}/>)}
          </InventoryGrid>
        </InventoryWrapper>
        <InventoryWrapper>
          <InventoryTitle>{MaterialType["crops"].label[lang]}</InventoryTitle>
          <InventoryGrid>
            {CropsMaterial.map((key) => <Item key={key} dataKey={key}/>)}
          </InventoryGrid>
        </InventoryWrapper>
        <InventoryWrapper>
          <InventoryTitle>{MaterialType["animal"].label[lang]}</InventoryTitle>
          <InventoryGrid>
            {AnimalMaterial.map((key) => <Item key={key} dataKey={key}/>)}
          </InventoryGrid>

        </InventoryWrapper>
      </InventoryPanelWrapper>
  )

}

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: `#000000`,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `#000000`,
    marginBottom: 0
  },
}));

const Item = ({ dataKey }) => {
  const { materialData, setMaterialData } = useStorageData();
  const { lang } = useLocalization();

  return(<BootstrapTooltip title={Material[dataKey].label[lang]} arrow placement="top">
    <div>
    <ItemImage src={Material[dataKey].icon} title={Material[dataKey].label[lang]} alt={Material[dataKey].label[lang]}/>
    <InventoryInput
      hiddenLabel
      value={materialData[dataKey]}
      size="small"
      onChange={(e) => {
        setMaterialData({
          key : dataKey,
          value : e.target.value
        })
      }}
    />
    </div>
  </BootstrapTooltip>)
}

export default InventoryPanel;

const InventoryPanelWrapper = styled.div`
  ${tw`
    bg-white
    rounded
    p-4 
    w-[334px]
    z-10
    h-[calc(100vh - 130px)]
    overflow-auto
  `}


`

const InventoryTitle = styled.div`
  ${tw`
    font-bold
    mb-2
    text-black
  `}
`

const InventoryGrid = styled.div`
  ${tw`
    grid
    gap-2
  `}

  grid-template: auto / repeat(7,36px);
`

const ItemImage = styled.img`
  ${tw`
    w-9
    h-9
    bg-gradient-to-b
    from-gray-800
    to-gray-600
    rounded
    border
  `}
`

const InventoryWrapper = styled.div`
  ${tw`
    mb-8
  `}

  &:last-of-type{
    ${tw`
      mb-0
    `}
  }
`

const InventoryInput = styled(TextField)`
  ${tw`
  w-9    
  inline-block

  `}
  input{
  ${tw`
    p-[2px]
    text-center
    text-[12px]
  `}
  }
`